import type { PaymentPlatform } from '../types'
import type { Product, Products } from './types'
import { ANNUAL_DOUBLE_TRIAL } from './annual-double-trial'
import { MONTHLY_7DAYS_TRIAL } from './monthly-7days-trial'
import { MONTHLY_NO_TRIAL, type DeployEnv } from './monthly-no-trial'

function wait(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

const annualOriginal: Product = {
  product_id: 21,
  receipt_system_product_id: 0,
  sku: 'forest_annual_1',
  product_type: 'subscription',
  duration: 'yearly',
  eligible_trial_days: 0,
  price_localized: '$200.00',
  price_value: 200,
  display_name: 'Annual Plan',
}

const annualEarlyBird: Product = {
  product_id: 22,
  receipt_system_product_id: 0,
  sku: 'forest_annual_early_bird',
  product_type: 'subscription',
  duration: 'yearly',
  eligible_trial_days: 7,
  price_localized: '$100.00',
  price_value: 100,
  display_name: 'Annual Plan (Early Bird)',
}

const monthlyOriginal: Product = {
  product_id: 23,
  receipt_system_product_id: 0,
  sku: 'forest_monthly_1',
  product_type: 'subscription',
  duration: 'monthly',
  eligible_trial_days: 0,
  price_localized: '$20.00',
  price_value: 20,
  display_name: 'Monthly Plan',
}

const monthlyEarlyBird: Product = {
  product_id: 24,
  receipt_system_product_id: 0,
  sku: 'forest_monthly_early_bird',
  product_type: 'subscription',
  duration: 'monthly',
  eligible_trial_days: 7,
  price_localized: '$10.00',
  price_value: 10,
  display_name: 'Monthly Plan (Early Bird)',
}

export async function canonicalMock(
  env: DeployEnv,
  platform: PaymentPlatform,
): Promise<Products> {
  await wait(1000)
  const noTrialConfig = MONTHLY_NO_TRIAL[env]?.[platform] ?? null
  const monthlyNoTrial: Product | null = noTrialConfig
    ? {
        product_id: noTrialConfig.product_id,
        receipt_system_product_id: 0,
        sku: noTrialConfig.sku,
        product_type: 'subscription',
        duration: 'monthly',
        eligible_trial_days: 0,
        price_localized: '$10.00',
        price_value: 10,
        display_name: 'Monthly Plan (No Trial)',
      }
    : null

  const doubleTrialConfig = ANNUAL_DOUBLE_TRIAL[env]?.[platform] ?? null
  const annualDoubleTrial: Product | null = doubleTrialConfig
    ? {
        product_id: doubleTrialConfig.product_id,
        receipt_system_product_id: 0,
        sku: doubleTrialConfig.sku,
        product_type: 'subscription',
        duration: 'yearly',
        eligible_trial_days: 14,
        price_localized: '$100.00',
        price_value: 100,
        display_name: 'Annual Plan (14-day trial)',
      }
    : null

  const sevenDaysTrialConfig = MONTHLY_7DAYS_TRIAL[env]?.[platform] ?? null
  const monthly7daysTrial: Product | null = sevenDaysTrialConfig
    ? {
        product_id: sevenDaysTrialConfig.product_id,
        receipt_system_product_id: 0,
        sku: sevenDaysTrialConfig.sku,
        product_type: 'subscription',
        duration: 'monthly',
        eligible_trial_days: 7,
        price_localized: '$10.00',
        price_value: 10,
        display_name: 'Monthly Plan (7-day trial)',
      }
    : null

  return {
    annualOriginal,
    annualEarlyBird,
    monthlyOriginal,
    monthlyEarlyBird,
    monthlyNoTrial,
    annualDoubleTrial,
    monthly7daysTrial,
  }
}
